import { createGenericStore } from '@/stores/utils/genericStore.js'
import axios from 'axios'
import { numericId, unwrapResource } from './chatStoreUtils.js'

const conversationStoreOptions = {
  state: () => ({
    isUpdatingConversation: false
  }),

  getters: {
    getConversationById(state) {
      return (conversationId) => state.items.find((conversation) => numericId(conversation.id) === numericId(conversationId)) || null
    }
  },

  actions: {
    patchConversationState(conversation) {
      if (!conversation?.id) {
        return
      }

      this.itemPatchState(conversation)
    },

    patchConversationParticipantState(conversationId, participant) {
      const conversation = this.getConversationById(conversationId)

      if (!conversation || !participant?.id) {
        return
      }

      const participants = Array.isArray(conversation.participants) ? [...conversation.participants] : []
      const participantIndex = participants.findIndex((item) => numericId(item.id) === numericId(participant.id))

      if (participantIndex > -1) {
        participants.splice(participantIndex, 1, participant)
      } else {
        participants.push(participant)
      }

      this.patchConversationState({
        ...conversation,
        participants,
        current_participant: numericId(conversation.current_participant?.user_id) === numericId(participant.user_id)
          ? participant
          : conversation.current_participant
      })
    },

    async fetchConversations(params = {}) {
      return this.fetchItems(params)
    },

    async fetchConversation(conversationId) {
      this.isLoading = true
      this.error = null

      try {
        const response = await axios.get(`${this.api}/${conversationId}`)
        const conversation = unwrapResource(response)
        this.patchConversationState(conversation)
        return conversation
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.isLoading = false
      }
    },

    async createConversation(payload) {
      this.isLoading = true
      this.error = null

      try {
        const response = await axios.post(this.api, payload)
        const conversation = unwrapResource(response)
        this.patchConversationState(conversation)
        return conversation
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.isLoading = false
      }
    },

    async updateConversation(conversationId, payload) {
      this.isUpdatingConversation = true
      this.error = null

      try {
        const response = await axios.patch(`${this.api}/${conversationId}`, payload)
        const conversation = unwrapResource(response)
        this.patchConversationState(conversation)
        return conversation
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.isUpdatingConversation = false
      }
    }
  }
}

export const useConversationStore = createGenericStore(
  'chat-conversations',
  '/api/v1/conversations',
  conversationStoreOptions
)
